import React from 'react'
import { Box, Divider, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { selectSendAfterMicInput, selectSendMessageOption, SendMessageOption, setSendAfterMicInput, setSendMessageOption } from '@/redux/ducks/ai/chat'
import { dispatch, useAppSelector } from '@/redux/store'
import lang from '@/lang'

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    padding: 16,
  },
  box: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  subtitle: {
    fontSize: theme.fontSizes.default,
    fontWeight: theme.fontWeights.medium,
  },
  description: {
    fontSize: theme.fontSizes.small,
    color: theme.textMuted,
  },
}))

export default function AiChatSettings() {
  const classes = useStyles()
  const sendMessageOption = useAppSelector(selectSendMessageOption)
  const sendAfterMicInput = useAppSelector(selectSendAfterMicInput)

  const handleSendMessageOptionChange = (event: React.MouseEvent<HTMLElement>, value: SendMessageOption) => {
    dispatch(setSendMessageOption(value))
  }
  const handleSendAfterMicInputChange = (event: React.MouseEvent<HTMLElement>, value: boolean) => {
    dispatch(setSendAfterMicInput(value))
  }

  return (
    <div className={classes.container}>
      <Typography variant="h6">{lang.ai.chat.settings.title}</Typography>
      <Divider />
      <Box component="div" className={classes.box}>
        <Typography className={classes.subtitle}>
          {lang.ai.chat.settings.sendMessageOption.title}
        </Typography>
        <Typography className={classes.description}>
          {lang.ai.chat.settings.sendMessageOption.description}
        </Typography>
        <ToggleButtonGroup
          color="primary"
          value={sendMessageOption}
          exclusive
          onChange={handleSendMessageOptionChange}
        >
          <ToggleButton value={SendMessageOption.ENTER}>{lang.ai.chat.settings.sendMessageOption.options.enter}</ToggleButton>
          <ToggleButton value={SendMessageOption.ENTER_CTRL}>{lang.ai.chat.settings.sendMessageOption.options.enterCtrl}</ToggleButton>
        </ToggleButtonGroup>
      </Box>
      <Divider />
      <Box component="div" className={classes.box}>
        <Typography className={classes.subtitle}>
          {lang.ai.chat.settings.sendAfterMicInput.title}
        </Typography>
        <Typography className={classes.description}>
          {lang.ai.chat.settings.sendAfterMicInput.description}
        </Typography>
        <ToggleButtonGroup
          color="primary"
          value={sendAfterMicInput}
          exclusive
          onChange={handleSendAfterMicInputChange}
        >
          <ToggleButton value={true}>{lang.ai.chat.settings.sendAfterMicInput.options.yes}</ToggleButton>
          <ToggleButton value={false}>{lang.ai.chat.settings.sendAfterMicInput.options.no}</ToggleButton>
        </ToggleButtonGroup>
      </Box>
    </div>
  )
}
